var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.dataList),function(item,index){return _c('Item',{key:index,attrs:{"item":item,"type":_vm.type},on:{"change":_vm.change}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }